// import external dependencies
import 'jquery';

import "./libs/formValidation/formValidation";
import "./libs/formValidation/framework/bootstrap";

// Import everything from the plugins folder.
import "./plugins/dmv-advisors-forms"; import "./plugins/dmv-advisors-forms/index.js"; import "./plugins/dmv-contact-forms"; import "./plugins/dmv-contact-forms/index.js"; import "./plugins/dmv-faq"; import "./plugins/dmv-faq/index.js"; import "./plugins/dmv-insurance-forms"; import "./plugins/dmv-insurance-forms/index.js"; import "./plugins/dmv-lawyers"; import "./plugins/dmv-lawyers/dui-form.js"; import "./plugins/dmv-lawyers/index.js"; import "./plugins/dmv-lawyers/otr-form.js"; import "./plugins/dmv-lawyers/pi-form.js"; import "./plugins/dmv-navigation"; import "./plugins/dmv-navigation/index.js"; import "./plugins/dmv-office"; import "./plugins/dmv-office/index.js"; import "./plugins/dmv-ols"; import "./plugins/dmv-ols/index.js"; import "./plugins/dmv-params"; import "./plugins/dmv-params/index.js"; import "./plugins/dmv-vin"; import "./plugins/dmv-vin/index.js"; import "./plugins/wp-smartpath"; import "./plugins/wp-smartpath/index.js";

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import vehicleHistoryReports from './routes/vehicle-history-reports';
import singleCounty from './routes/single-county';
import singleCity from './routes/single-city';
import singleOffice from './routes/single-office';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // VIN Pages
  vehicleHistoryReports,

  singleCounty,

  singleCity,

  singleOffice,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js